<template>
  <div>
    <van-sticky>
      <nav-bar class="home-nav">
        <div slot="left" @click="onClickLeft">返回</div>
        <div slot="center">免测申请学生管理({{ countStu }})</div>
        <div slot="right">
          <van-popover
            v-model="showPopover"
            trigger="click"
            :actions="actions"
            theme="dark"
            placement="bottom-end"
            @select="onOperate"
          >
            <template #reference>
              操作
            </template>
          </van-popover>
        </div>
      </nav-bar>

      <van-search
        v-model="searchValue"
        show-action
        placeholder="请输入姓名或学号关键词"
        @search="onSearch"
        @cancel="onCancel"
      />
      <van-field
        v-model="fieldValue"
        is-link
        readonly
        label="筛选"
        placeholder="请选择筛选条件"
        @click="show = true"
      />
      <van-popup v-model="show" round position="bottom">
        <van-cascader
          title="请选择筛选条件"
          :options="options"
          @close="show = false"
          @finish="onFinish"
        />
      </van-popup>
    </van-sticky>

    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
        loading-text="努力加载中"
      >
        <van-swipe-cell v-for="(item,index) in studentList" :key="item.id">
          <!--        <template slot="left">-->
          <!--          <van-button square type="primary" text="选择"/>-->
          <!--        </template>-->
          <van-cell :border="false"
                    :value="item.snum">
            <template #title>
            <span class="custom-title">{{
                '(' + ((currentPage - 1) * 10 + (index + 1)) + ') ' + item.sname + ' ' + item.gender + ' '
              }}</span>
              <van-tag :type="item.passed>1?'success ':'danger'">{{ item.passed > 1 ? '已审核' : '未审核' }}</van-tag>
              <van-tag :type="item.passed==3?'success ':'danger'">{{ item.passed == 3 ? '通过' : '未过' }}</van-tag>
              <van-tag type="primary">{{ item.years+item.halfs }}半年度</van-tag>
            </template>
          </van-cell>
          <template slot="right">
            <van-button square type="primary" @click="detail(item.id)" text="详细"/>
            <van-button square type="danger" @click="delStudent(item.id)" text="删除"/>
          </template>

        </van-swipe-cell>
      </van-list>
    </van-pull-refresh>

    <!--    分页-->
    <van-pagination
      v-model="currentPage"
      :total-items="125"
      :page-count="pageCount"
      :show-page-size="5"
      force-ellipses
      @change="onPageChange"
      style="bottom: 0;position: fixed; width: 100%;padding-top: 20px"
    />

    <van-action-sheet v-model="detailShow" :title="sname">
      <div style="margin-top: 50px;margin-bottom: 50px">
        <van-cell title="姓名" :value="this.sname"/>
        <van-cell title="学号" :value="this.snum"/>
        <van-cell title="性别" :value="this.gender"/>
        <van-cell title="申请时间" :value="this.createDate"/>

        <van-swipe style="height: 200px;">
          <van-swipe-item v-for="(image, index) in images" @click="onSwipeChange(index)" :key="index">
            <img style="width: 100%;padding: 20px" v-lazy="image"/>
          </van-swipe-item>
        </van-swipe>

        <van-cell center title="是否通过">
          <template #right-icon>
            <van-switch v-model="passed" size="24"/>
          </template>
        </van-cell>
        <van-form @submit="onSubmit">

          <div style="margin: 16px;">
            <van-button round block type="info" native-type="submit">
              提交
            </van-button>
          </div>
        </van-form>
      </div>
    </van-action-sheet>

  </div>
</template>

<script>
import Vue from 'vue';
import {
  Cell, Search, List, SwipeCell, Button, Dialog, Toast, Sticky, PullRefresh, Pagination, Tag,
  ActionSheet, Switch, Form, Field, Rate, Swipe, SwipeItem, Lazyload, ImagePreview, Popover, Cascader, Popup, Icon
} from 'vant';
import NavBar from "components/common/navbar/NavBar";
import {
  GetNoTestListLikeKeyByPage,
  DelStudentInNoTestById,
  GetNoTestCountByKey,
  modifyStuInfoInNoTestById,
  GetNoTestInfo,
  GetNoTestDownLoad,
  DeleteNoTest
} from "../../../network/no_test";
import {DelCourseById, GetCourseScoreDownLoad} from "../../../network/course";

Vue.use(Cell)
Vue.use(Search)
Vue.use(List)
Vue.use(SwipeCell)
Vue.use(Button)
Vue.use(Dialog)
Vue.use(Toast)
Vue.use(Sticky)
Vue.use(PullRefresh)
Vue.use(Pagination)
Vue.use(Tag)
Vue.use(ActionSheet)
Vue.use(Switch)
Vue.use(Form)
Vue.use(Field)
Vue.use(Rate)
Vue.use(Swipe)
Vue.use(SwipeItem)
Vue.use(Lazyload)
Vue.use(ImagePreview)
Vue.use(Popover)
Vue.use(Cascader)
Vue.use(Popup)
export default {
  name: "NoTestApplyList",
  components: {
    NavBar
  },
  data() {
    return {
      // Cascader
      show: false,
      fieldValue: '',
      // 选项列表，children 代表子选项，支持多级嵌套
      options: [
        // {
        //   text: '2022',
        //   value: '2022',
        //   children: [{text: '未通过', value: '0'}, {text: '已通过', value: '1'}],
        // },
        // {
        //   text: '2021',
        //   value: '2021',
        //   children: [{text: '未通过', value: '0'}, {text: '已通过', value: '1'}],
        // },
      ],
      // Popover
      showPopover: false,
      // 通过 actions 属性来定义菜单选项
      actions: [{text: '下载全部'}, {text: '下载当前筛选'}, , {text: '删除全部'}, , {text: '删除当前筛选'}],
      //tab
      activeYear: "1999",
      activeStatus: "未通过",

      studentList: [],
      searchValue: '',
      countStu: 0,

      //refresh
      refreshing: false,
      loading: false,
      finished: true,

      //分页
      currentPage: 0,

      //action sheet
      detailShow: false,
      id: 0,
      sname: "",
      snum: "",
      gender: "",
      createDate: "",
      img1: "",
      img2: "",
      passed: 0,

      images: [],

    }
  },
  mounted() {
    this.getNoTestCountByKey(this.searchValue);
    this.getStuListLikeKeyByPageInNoTest("");
    // options: [
    //   {
    //     text: '2022',
    //     value: '2022',
    //     children: [{text: '未通过', value: '0'}, {text: '已通过', value: '1'}],
    //   },
    //   {
    //     text: '2021',
    //     value: '2021',
    //     children: [{text: '未通过', value: '0'}, {text: '已通过', value: '1'}],
    //   },
    // ],
    this.options = [];
    let year = new Date().getFullYear();
    for (let i = year; i >= 2021; i--) {
      this.options.push({
        text: i,
        value: i,
        children: [{text: '未通过', value: '0'}, {text: '已通过', value: '1'}]
      })
    }
  },
  computed: {
    pageCount() {
      if (this.countStu % 10 === 0)
        return this.countStu / 10;
      return parseInt(this.countStu / 10) + 1;
    },
  },
  methods: {
    // Cascader
    onFinish({selectedOptions}) {
      this.show = false;
      this.fieldValue = selectedOptions.map((option) => option.text).join('/');
      let value = this.fieldValue.split("/");
      this.activeYear = value[0];
      this.activeStatus = value[1];
      this.getStuListLikeKeyByPageInNoTest(this.searchValue);
      this.getNoTestCountByKey(this.searchValue);
    },
    // Popover
    onOperate({text}) {
      let title = "全部免测申请人员";
      let type = 1;
      if (text.indexOf('下载') != -1) {
        if (text != "下载全部") {
          title = this.activeYear + this.activeStatus + '免测申请人员'
          type = 2;
        }
        Dialog.confirm({
          title: '提示',
          message: '确定要下载' + title + '吗'
        }).then(() => {
          GetNoTestDownLoad(type, this.activeYear, this.activeStatus).then(res => {
            const content = res
            const blob = new Blob([content])
            const fileName = title + '.xlsx'
            if ('download' in document.createElement('a')) { // 非IE下载
              const elink = document.createElement('a')
              elink.download = fileName
              elink.style.display = 'none'
              elink.href = URL.createObjectURL(blob)
              document.body.appendChild(elink)
              elink.click()
              URL.revokeObjectURL(elink.href) // 释放URL 对象
              document.body.removeChild(elink)
            } else { // IE10+下载
              navigator.msSaveBlob(blob, fileName)
            }
          }).catch(err => {
            Dialog.alert({
              message: '下载文件出错',
            });
          })
          // on confirm
        }).catch(() => {
          // on cancel
        });
      } else {
        if (text != "删除全部") {
          title = this.activeYear + this.activeStatus + '免测申请人员'
          type = 2;
        }
        Dialog.confirm({
          title: '提示',
          message: '确定要删除' + title + '吗'
        }).then(() => {
          DeleteNoTest(type, this.activeYear, this.activeStatus).then(res => {
            if (res) {
              Toast('刷新成功');
              this.studentList = [];
            } else {
              Toast('刷新失败');
            }
          })
          // on confirm
        }).catch(() => {
          // on cancel
        });
      }

    },
    //refresh
    onLoad() {
      setTimeout(() => {
        this.refreshing = false;
        Toast('刷新成功');
      }, 1500);
    },
    onRefresh() {
      // 清空列表数据;
      this.studentList = [];
      // 将 loading 设置为 true，表示处于加载状态
      //this.loading = true;
      this.onLoad();
      setTimeout(() => {
        // 重新加载数据
        this.getNoTestCountByKey(this.searchValue);
        this.getStuListLikeKeyByPageInNoTest(this.searchValue);
        this.isLoading = false;
      }, 1000);
    },
    onSearch(val) {
      this.getStuListLikeKeyByPageInNoTest(this.searchValue);
      this.getNoTestCountByKey(this.searchValue);
    },
    onCancel() {
      this.getStuListLikeKeyByPageInNoTest("");
      this.getNoTestCountByKey();
    },
    onPageChange() {
      this.getStuListLikeKeyByPageInNoTest(this.searchValue, this.currentPage);
    },
    getStuListLikeKeyByPageInNoTest(name, page = 1) {
      GetNoTestListLikeKeyByPage(name, this.activeYear, this.activeStatus, page).then(res => {
        this.studentList = res;
      });
    },
    getNoTestCountByKey(key = "") {
      GetNoTestCountByKey(key, this.activeYear, this.activeStatus,).then(res => {
        this.countStu = res;
      });
    },

    delStudent(id) {
      Dialog.confirm({
        title: '提示',
        message: '确定要删除吗'
      }).then(() => {
        DelStudentInNoTestById(id).then(res => {
            if (res) {
              this.studentList = this.studentList.filter(item => item.id != id);
              this.countStu = this.countStu - 1;
              Toast.success('刪除成功');
            } else {
              Toast.fail('删除失败');
            }
          }
        );
        // on confirm
      }).catch(() => {
        // Toast.fail('删除失败');
        // on cancel
      });
    },
    formatDate(date) {
      return `${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()} ${date.getHours()}:${date.getMinutes()}`;
    },
    detail(id) {
      this.detailShow = true;
      //     name: "",
      //     phone: "",
      //     school: "",
      //     passed: 0,
      //     evaluation: "",
      GetNoTestInfo(id).then(res => {
        this.id = res.info.id;
        this.sname = res.info.sname;
        this.snum = res.info.snum;
        this.gender = res.info.gender;
        this.createDate = this.formatDate(new Date(res.info.createDate));
        this.img1 = res.info.img1;
        this.img2 = res.info.img2;
        this.passed = res.passed === 1 ? true : false;
        this.images = [];
        this.images.push(res.info.img1);
        this.images.push(res.info.img2);
      })


    },
    onClickLeft() {
      // this.$router.back(-1);
      this.$router.replace("/more");
    },
    onSubmit(values) {
      modifyStuInfoInNoTestById(this.id, this.passed ? 3 : 2, this.ranks, this.evaluation).then(res => {
          if (res) {
            this.studentList = this.studentList.map(res => {
              if (res.id === this.id) {
                this.passed ? res.passed = 3 : res.passed = 2;
              }
              return res;
            })
            Toast.success('修改成功');
          } else {
            Toast.fail('修改失败');
          }
        }
      );
    },
    onSwipeChange(index) {
      ImagePreview({
        images: this.images,
        closeable: true,
        startPosition: index,
      });
    }
  }
}
</script>

<style scoped>
.home-nav {
  background-color: var(--color-tint);
  color: #fff;
}
</style>
